module.exports = __webpack_public_path__ + "static/img/Store-3.7809042f.png";